import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { SelectBox } from "devextreme-react/select-box";
import { Button, Popup, TextBox, ToolbarItem } from "devextreme-react";
import { useHistory } from "react-router-dom";
import {
    Column,
    DataGrid,
    GroupPanel,
    Lookup,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
    LoadPanel
} from "devextreme-react/data-grid";
import { ValidationGroup } from 'devextreme-react/validation-group';
import DOMPurify from "dompurify";

import Toolbar, { Item } from "devextreme-react/toolbar";
import { Localization } from "../common/Localization";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { connect } from "react-redux";
import GridLayoutManager from "../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../common/GridLayout";
import { alert, confirm, custom } from 'devextreme/ui/dialog';
import Validator, { RequiredRule, CustomRule } from 'devextreme-react/validator';
import ContextMenu from 'devextreme-react/context-menu';
import { MESSAGES } from "../common/Messages";
import { DynamicLookupOptions } from "../enum/Enum";
import sanitizeHtml from "../common/sanitizeHtml";
const menuItems = [
    { text: 'Edit - Full Screen', disabled: false },
    { text: 'Edit - Quick Screen', disabled: false }
];
const DynamicFromLookup = (props) => {
    var accessToken = props.oidc.user.access_token;
    let field = props.field;
    let formFields = props.formFields;
    const history = useHistory();
    const gridRef = useRef(null);
    const cntxtMenuRef = useRef(null);
    const textBoxRef = useRef(null);
    const gridKey = props.layout.gridKey;
    const key = props.layout.valueExpr;
    const value = formFields[field.name]?.toString().trim();
    const [gridDataSource, setGridDatasource] = useState(null);
    const [selectBoxDataSource, setSelectBoxDatasource] = useState(null);
    const [textBoxDataSource, setTextBoxDatasource] = useState(null);
    const [popupVisible, setPopupVisible] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [customPopupVisible, setCustomPopupVisible] = useState(false);
    const [customPopupQuickVisible, setCustomPopupQuickVisible] = useState(false);
    const [customTypedText, setCustomTypedText] = useState("");
    const [currentLayout, setCurrentLayout] = useState("Default");
    const [showUserDefinedPopUp, setShowUserDefinedPopUp] = useState(false);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const [safeHtml, setSafeHtml] = useState("");
    let label = ""
    if (field) {
        let fieldName = field?.localizedField ? field.localizedField : field.name;
        label = field.ignoredblocalization ? field.label : (field.isLabelChanged ? field.label : Localization.formatMessage(`${field.tableName}.${fieldName}`, field.label));
    }
    function updateRuntimeParams(params, formFields) {
        if (!params?.runtimeParameter) return params;

        let parsedRuntimeParams = [];

        try {
            parsedRuntimeParams = JSON.parse(params.runtimeParameter);
        } catch (err) {
            console.error('Invalid runtimeParameter JSON:', err);
            return params; // return original if JSON parsing fails
        }

        const updatedRuntimeParams = parsedRuntimeParams.map(item => {
            const key = Object.keys(item)[0];
            const updatedValue = formFields?.[key]?.toString().trim() ?? item[key];
            return { [key]: updatedValue };
        });

        return {
            ...params,
            runtimeParameter: JSON.stringify(updatedRuntimeParams)
        };
    }
    const updatedParams = updateRuntimeParams(props.layout.params, formFields);
    const handleSelectBoxValueChange = (event) => {
        if (event.value && event.value[props.layout.valueExpr]) {
            if (event.value.popupmessage !== null && event.value.popupmessage !== "" && event.value.popupmessage !== undefined) {
                setSafeHtml(DOMPurify.sanitize(event.value.popupmessage));
                setShowUserDefinedPopUp(true);
            }
            event.value = event.value[props.layout.valueExpr];
            props.onValueChanged(event);
        }

    };
    const handleSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length > 0) {
            setSelectedRowData(selectedRowsData[0]);
            if (typeof props.handleSelectionChange  === 'function') {
                props.handleSelectionChange(field.name, selectedRowsData[0]);
            }
        }
    }
    const togglePopup = () => {
        setPopupVisible(!popupVisible);
    };
    const hidePopup = () => {
        if (selectedRowData) {
            if (field) {
                loadTextBoxValue(selectedRowData[props.layout.displayExpr], selectedRowData[props.layout.valueExpr], true);
            }
        }
        setPopupVisible(!popupVisible);
    };
    const OpenCustomValuePopup = (e) => {
        const typedText = e.text;
        const layoutParams = props?.layout?.params || {};
        const hasFullComponent = !!layoutParams.onCustomItemCreatingComponent;
        const hasQuickComponent = !!layoutParams.onCustomItemCreatingQuickComponent;
        if (!typedText) {
            let e = {};
            e.value = null;
            e.selectedvalue = null;
            e.text = null;
            props.onValueChanged(e);
            return;
        }

        if (
            typedText &&
            typedText !== formFields[field.name]?.toString().trim()
        ) {
            const customItem = {
                [props.layout.valueExpr]: typedText,
                [props.layout.displayExpr]: typedText
            };
            e.customItem = new Promise((resolve, reject) => {
                if (hasFullComponent && hasQuickComponent) {
                    const layoutParams = props?.layout?.params || {};
                    layoutParams.isEdit = false;
                    custom({
                        title: "Confirmation",
                        messageHtml: `<p>''${typedText}'' Not Found. Add to Database?</p>`,
                        buttons: [
                            { text: "Yes - Full", onClick: () => "full" },
                            { text: "Yes - Quick", onClick: () => "quick" },
                            { text: "No", onClick: () => null },
                        ],
                    }).show().then((result) => {
                        if (result === "full") {
                            setCustomTypedText(typedText);
                            setCustomPopupVisible(true);
                            resolve(customItem);
                        } else if (result === "quick") {
                            setCustomTypedText(typedText);
                            setCustomPopupQuickVisible(true);

                            resolve(typedText);
                        } else {
                            resolve(null);
                        }
                    });
                }
                else if (hasFullComponent) {
                    confirm(`''${typedText}'' Not Found. Add to Database?`, "Confirm").then((dialogResult) => {
                        if (dialogResult) {
                            setCustomTypedText(typedText);
                            setCustomPopupVisible(true);
                            resolve(typedText);
                        } else {
                            resolve(null);
                        }
                    });
                }
                else if (hasQuickComponent) {
                    custom({
                        title: "Add New Value",
                        messageHtml: `<p>This value does not exist. Would you like to quick add it?</p>`,
                        buttons: [
                            { text: "Quick Add", onClick: () => "quick" },
                            { text: "Cancel", onClick: () => null },
                        ],
                    }).show().then((result) => {
                        if (result === "quick") {
                            setCustomTypedText(typedText);
                            setCustomPopupQuickVisible(true);
                            resolve(customItem);
                        } else {
                            resolve(null);
                        }
                    });
                }
                else {
                    resolve(null);
                }
            });
        }
    };

    const loadSelectBoxDataSource = () => {
        var dataSource = new DataSource({
            store: new createStore({
                key: props.layout.valueExpr,
                loadUrl: `${window._env_.REACT_APP_APIS}/common/Lookup/GetLookup`,
                loadParams: {
                    ...updatedParams,
                    showLookupGrid: false,

                }, onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: props.layout.sort,
            paginate: true,
            pageSize: 100
        });
        if (props.field.lookupDisplayMode !== DynamicLookupOptions.GridDisplayMode) {
            setSelectBoxDatasource(dataSource);
        }
        return dataSource;
    };

    const lookupTextBoxChanged = (e) => {
        loadTextBoxValue(e.value);
    }
    const initialTextBoxValue = () => {
        const value = formFields[field.name]?.toString().trim();
        if (props.field.lookupDisplayMode === DynamicLookupOptions.GridDisplayMode) {
            const key = props.layout.valueExpr;
            if (!value && textBoxRef.current) {
                textBoxRef.current.instance().option('value', "");
                return;
            }
            const ds = loadSelectBoxDataSource();
            ds.filter(key, "=", value);
            ds.load().then(data => {
                if (textBoxRef.current) {
                    if (data.length > 0) {
                        const textToSet = data[0][props.layout.displayExpr];
                        textBoxRef.current.instance().option('value', textToSet);
                    }
                    else {
                        textBoxRef.current.instance().option('value', "");
                    }
                }
            }).catch(error => {
                console.error(MESSAGES.FETCH_ERROR, error);
            });
        }
    }

    const loadTextBoxValue = (displayExpr, valueExpr = null, loadOnPopupClose = false) => {
        if (props.field.lookupDisplayMode === DynamicLookupOptions.GridDisplayMode) {
            const key = props.layout.displayExpr;
            let e = {};
            e.value = null;
            e.selectedvalue = null;
            e.text = null;
            if (!displayExpr && textBoxRef.current) {
                textBoxRef.current.instance().option('value', "");
                props.onValueChanged(e);
                return;
            }
            if (loadOnPopupClose && textBoxRef.current) {
                textBoxRef.current.instance().option('value', displayExpr);
                e.value = valueExpr;
                e.selectedvalue = valueExpr;
                props.onValueChanged(e);
                return;
            }
            const ds = loadSelectBoxDataSource();
            ds.filter(key, "=", displayExpr);
            ds.load().then(data => {
                if (textBoxRef.current) {
                    if (data.length > 0) {
                        const valueToSet = data[0][props.layout.valueExpr];
                        const textToSet = data[0][props.layout.displayExpr];
                        textBoxRef.current.instance().option('value', textToSet);
                        e.value = valueToSet;
                        e.selectedvalue = valueToSet;
                        e.text = textToSet;
                        props.onValueChanged(e);
                    }
                    else {
                        textBoxRef.current.instance().option('value', "");
                        e.value = null;
                        e.text = null;
                        OpenCustomValuePopup(e);
                    }
                }
            }).catch(error => {
                console.error(MESSAGES.FETCH_ERROR, error);
            });
        }
        else{
            let e={};
                e.value = valueExpr;
                e.selectedvalue = displayExpr;
                e.text = displayExpr;
                props.onValueChanged(e);
            }
    }
    const runtimeParamKeys = useMemo(() => {
        try {
            const runtimeParam = JSON.parse(
                props?.layout?.params?.runtimeParameter || '[]'
            );

            if (!Array.isArray(runtimeParam)) {
                return [];
            }

            return runtimeParam.map(obj => Object.keys(obj)[0]);
        } catch (e) {
            console.warn("Invalid runtimeParameter JSON:", e);
            return [];
        }
    }, [props?.layout?.params?.runtimeParameter]);

    const runtimeParamValues = useMemo(() => {
        return runtimeParamKeys.map(key => formFields?.[key]);
    }, [formFields, runtimeParamKeys]);
    const hasInitialized = useRef(false);

    useEffect(() => {
        const value = formFields[field.name]?.toString().trim();
        if (!value) {
            if (textBoxRef.current) {
                textBoxRef.current.instance().option('value', "");
            }
            return;
        }
        if (!hasInitialized.current && formFields[field.name]) {
            initialTextBoxValue();
            hasInitialized.current = true;
        }
    }, [formFields[field.name]]);
    useEffect(() => {
        loadSelectBoxDataSource();
    }, runtimeParamValues.length > 0 ? runtimeParamValues : []);

    useEffect(() => {
        if (selectedRowData && selectedRowData.popupmessage !== null && selectedRowData.popupmessage !== "" && selectedRowData.popupmessage !== undefined && !popupVisible) {
            setSafeHtml(DOMPurify.sanitize(selectedRowData.popupmessage));
            setShowUserDefinedPopUp(true);
        }
        if (popupVisible) {
            loadGridDataSource(true);
        }
    }, [popupVisible])

    const loadGridDataSource = (isFilterd = false) => {
        var gridDataSource = new DataSource({
            store: new createStore({
                key: props.layout.valueExpr,
                loadUrl: `${window._env_.REACT_APP_APIS}/common/Lookup/GetLookup`,
                loadParams: {
                    ...updatedParams
                }, onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: props.layout.sort,
        });
        
        if (isFilterd && props.field.lookupDisplayMode === DynamicLookupOptions.GridDisplayMode && textBoxRef.current) {
            const value = textBoxRef.current.instance().option('value');
            const key = props.layout.displayExpr;
            gridDataSource.filter(key, "contains", value);
        }
        else if (isFilterd && formFields[field.name]) {
            const key = props.layout.valueExpr;
            gridDataSource.filter(key, "=", formFields[field.name]?.toString().trim());
        }
        setGridDatasource(gridDataSource);
    }
    const newValuePopupHide = () => {
        setCustomPopupVisible(false);
    }
    const handleReset = () => {
        loadGridDataSource(false);
    }
    const refreshDynamicLookup = (valueExpr, dispExpr) => {
        if (field) {
            let e = {};
            e.value = valueExpr;
            e.selectedvalue = dispExpr;
            props.onValueChanged(e);
        }
    }
    const handleContextMenu = (e) => {
        e.preventDefault();
        const menu = cntxtMenuRef.current.instance();
        if (formFields[field.name] !== null && formFields[field.name] !== undefined && formFields[field.name] !== '')
            menuItems.filter(i => i.disabled = false);
        else
            menuItems.filter(i => i.disabled = true);
        menu.option('dataSource', menuItems);
        menu.show();
    };

    const handleMenuItemClick = (e) => {
        const selectedItem = e.itemData.text;
        const value = formFields[field.name]?.toString().trim();
        const layoutParams = props?.layout?.params || {};
        layoutParams.isEdit = true;
        setCustomTypedText(value);
        if (selectedItem === "Edit - Full Screen") {
            setCustomPopupVisible(true);
        }
        else if (selectedItem === "Edit - Quick Screen") {
            setCustomPopupQuickVisible(true);
        }
    };
    useEffect(() => {
        if (props.field.lookupDisplayMode === DynamicLookupOptions.GridDisplayMode) {
            // give the parent our ref when mounted
            props.fieldRef(textBoxRef.current);
        }
    }, [props.fieldRef, props.field.lookupDisplayMode]);

    return (
        <>
            {props.field.lookupDisplayMode === DynamicLookupOptions.GridDisplayMode ? (
                <TextBox
                    ref={textBoxRef}
                    name={props.name}
                    onValueChanged={lookupTextBoxChanged}
                    stylingMode="outlined"
                    labelMode="static"
                    label={label}
                    readOnly={field.readOnly ? true : false}
                    buttons={[
                        {
                            name: "lookup",
                            location: "after",
                            options: {
                                icon: "find",
                                onClick: () => togglePopup(), // your grid popup
                                stylingMode: "text",
                                type: "default"
                            }
                        }
                    ]}
                >{props.required && <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
                </TextBox>
            ) : (
                <div onContextMenu={handleContextMenu} key={props.name}>
                    <SelectBox
                        style={{ pointerEvents: props.editMode ? "none" : "auto", opacity: props.editMode ? 0.5 : 1 }}
                        ref={props.fieldRef}
                        name={props.name}
                        className={props.name}
                        dataSource={selectBoxDataSource}
                        valueField={props.layout.valueExpr}
                        displayExpr={props.layout.displayExpr}
                        value={formFields[field.name]?.toString().trim()}
                        readOnly={field.readOnly ? true : false}
                        onValueChanged={handleSelectBoxValueChange}
                        onSelectionChanged={(e) => {
                            if (typeof props.handleSelectionChange === 'function') {
                                props.handleSelectionChange(field.name, e);
                            }
                        }}
                        stylingMode="outlined"
                        labelMode="static"
                        label={label}
                        searchEnabled={props.layout.searchEnabled !== undefined ? props.layout.searchEnabled : true}
                        acceptCustomValue={props.layout.acceptCustomValue ? true : false}
                        onCustomItemCreating={OpenCustomValuePopup}
                        searchMode="contains"
                        buttons={props.layout.params?.showLookupGrid ? [{
                            name: "lookup",
                            location: "after",
                            options: {
                                icon: "find",
                                onClick: () => togglePopup(),
                                stylingMode: "text",
                                type: "default"
                            }
                        }] : []}
                    >

                        {props.required && <Validator><RequiredRule message={`${field.label} is required`} /></Validator>}
                    </SelectBox>
                </div>
            )}
            <Popup
                visible={popupVisible}
                onHiding={hidePopup}
                width="80vw"
                title="Select Item"
                showCloseButton={true}
                toolbarItems={[
                    {
                        widget: "dxButton",
                        toolbar: "bottom",
                        location: "after",
                        options: {
                            text: "Done",
                            onClick: hidePopup,
                            stylingMode: "contained",
                            type: "default",
                            elementAttr: {
                                class: "accordianButton",
                            }
                        },
                    }
                ]}
                contentRender={() => (
                    <div>
                        {popupVisible === true && (
                            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                                ref={gridRef}
                                dataSource={gridDataSource}
                                showBorders={true}
                                className='LookupGridHeight'
                                onSelectionChanged={handleSelectionChanged}
                                columnAutoWidth={true}
                                remoteOperations={true}
                                searchEnabled={true}
                                hoverStateEnabled={true}
                                allowColumnReordering={true}
                                allowColumnResizing={true}
                            >
                                <ColumnHeaderFilter />
                                <HeaderFilter enabled={true} visible={false} />

                                <LoadPanel enabled={true} />
                                <StateStoring
                                    enabled={true}
                                    type="custom"
                                    customLoad={loadState}
                                    storageKey={gridKey}
                                    customSave={saveState}
                                />
                                <Selection mode="single" />
                                <Paging defaultPageSize={10} />
                                <Sorting visible={false} />
                                <ColumnChooser
                                    enabled={true}
                                    title="Choose Column"
                                    width={290}
                                    height={290}
                                    sortOrder="asc"
                                >
                                    <ColumnChooserSearch
                                        enabled={true}
                                        editorOptions={{ placeholder: 'Search column' }} />
                                </ColumnChooser>
                                <Export enabled={true} allowExportSelectedData={true} />

                                <Pager
                                    visible={true}
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 20, 50, 300, 500, 1000]}
                                    showNavigationButtons={true}
                                />
                                <FilterRow visible={true} applyFilter="auto" />
                                <FilterPanel visible={true} />
                                <GroupPanel visible={true} />
                                <Grouping autoExpandAll={false} />
                                {props.layout.columns.map((column, index) => {
                                    return (
                                        <Column
                                            key={index}
                                            dataField={column.dataField}
                                            caption={column.caption}
                                            format={column.format}
                                            dataType={column.dataType}
                                            visible={column.visible}
                                        >
                                            {column.lookupSource?.length > 0 && (
                                                <Lookup
                                                    dataSource={column.lookupSource}
                                                    displayExpr="text"
                                                    valueExpr="key"
                                                />
                                            )}
                                        </Column>
                                    );
                                })}


                                <GridToolbar>
                                    <GridItem location="before">
                                        <Button className="accordianButton" onClick={handleReset} text="Show All Records" type="default" />
                                    </GridItem>
                                    <GridItem location="after">
                                        <GridLayoutManager gridKey={gridKey} dataGrid={gridRef} setCurrentLayout={setCurrentLayout} />
                                    </GridItem>
                                    <GridItem name="exportButton" />
                                    <GridItem name="columnChooserButton" />
                                </GridToolbar>
                                <Paging enabled={true} />
                            </DataGrid>
                        )}
                    </div>
                )} />
            {customPopupVisible && (() => {
                const CustomComponent = props?.layout?.params?.onCustomItemCreatingComponent;
                const customComponentParams = props?.layout?.params || {};
                return CustomComponent ? (
                    <Popup
                        visible={customPopupVisible}
                        onHiding={() => setCustomPopupVisible(false)}
                        width="100vw"
                        height="100vh"
                        title={`Add/Edit: ${customTypedText}`}
                        showCloseButton={true}
                    >
                        <ValidationGroup>
                            <CustomComponent
                                typeText={customTypedText}
                                {...customComponentParams}
                                refreshDynamicLookup={refreshDynamicLookup}
                                setCustomPopupVisible={setCustomPopupVisible}
                                closePopup={() => setCustomPopupVisible(false)}
                            />
                        </ValidationGroup>
                    </Popup>
                ) : null;
            })()}
            {customPopupQuickVisible && (() => {
                const CustomComponent = props?.layout?.params?.onCustomItemCreatingQuickComponent;
                const customComponentParams = props?.layout?.params?.customComponentParams || {};

                return CustomComponent ? (
                    <Popup
                        visible={customPopupQuickVisible}
                        onHiding={() => setCustomPopupQuickVisible(false)}
                        width="60vw"
                        height="auto"
                        title={`Quick Add: ${customTypedText}`}
                        showCloseButton={true}
                    >
                        <CustomComponent
                            typeText={customTypedText}
                            refreshDynamicLookup={refreshDynamicLookup}
                            {...customComponentParams}
                            setCustomPopupQuickVisible={setCustomPopupQuickVisible}
                            closePopup={() => setCustomPopupQuickVisible(false)}
                        />
                    </Popup>
                ) : null;
            })()}
            <ContextMenu
                dataSource={menuItems}
                ref={cntxtMenuRef}
                target={"." + props.name}
                onItemClick={handleMenuItemClick}
            />
            {showUserDefinedPopUp && (
                <Popup
                    visible={showUserDefinedPopUp}
                    onHiding={() => setShowUserDefinedPopUp(false)}
                    width="60vw"
                    height="30vw"
                    title="User Defined Popup"
                    showCloseButton={true}
                >
                    <div
                        style={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {/* Scrollable Content Area */}
                        <div
                            style={{
                                flexGrow: 1,
                                overflowY: "auto",
                                padding: "1rem",
                            }}
                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(safeHtml) }}
                        />

                        {/* Sticky Footer Button */}
                        <div
                            style={{
                                borderTop: "1px solid #ccc",
                                padding: "1rem",
                                textAlign: "center",
                            }}
                        >
                            <Button
                                type="default"
                                onClick={() => setShowUserDefinedPopUp(false)}
                                text="Ok"
                            />
                        </div>
                    </div>
                </Popup>

            )}
        </>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(DynamicFromLookup);